module.exports = __webpack_public_path__ + "img/vip-banner-bg.72aff123.png";